/**
 * @fileoverview GET handler for the
 * "/integrations/direct/cdi/sources/:source_id/distinct_column_values" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { integrationsDirectCdiSourcesSourceIdDistinctColumnValues } from "./constants";
import type {
  GetIntegrationsDirectCdiSourcesSourceIdDistinctColumnValuesProps,
  GetIntegrationsDirectCdiSourcesSourceIdDistinctColumnValuesResult,
} from "./types";
import { isGetIntegrationsDirectCdiSourcesSourceIdDistinctColumnValuesResult } from "./validators";

export const getIntegrationsDirectCdiSourcesSourceIdDistinctColumnValues = reactQueryFetcherAdapter(
  integrationsDirectCdiSourcesSourceIdDistinctColumnValues,
  (
    signal: AbortSignal,
    { sourceId, tableName, columnName }: GetIntegrationsDirectCdiSourcesSourceIdDistinctColumnValuesProps
  ): Promise<GetIntegrationsDirectCdiSourcesSourceIdDistinctColumnValuesResult> => {
    return fetch<GetIntegrationsDirectCdiSourcesSourceIdDistinctColumnValuesResult>(
      `/integrations/direct/cdi/sources/${sourceId}/distinct_column_values`,
      "GET",
      { table_name: tableName, column_name: columnName },
      { signal },
      // The mapper renders a failed read inline next to the picker, so keep it off the root
      // error boundary's modal.
      { propagateFetchRequestError: false }
    );
  },
  isGetIntegrationsDirectCdiSourcesSourceIdDistinctColumnValuesResult
);
